export default {"src":"/_next/static/media/investment-icon.576eac47.svg","height":76,"width":94,"blurWidth":0,"blurHeight":0};